module.exports = __webpack_public_path__ + "img/activity-no-data.99edb1b1.png";